module.exports = __webpack_public_path__ + "static/img/image_home_product_01.8ccbf0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/home/image_home_product_01.png
// module id = Acfu
// module chunks = 10